import React from 'react';
import { useNavigate } from 'react-router-dom';
import { FaExclamationTriangle, FaArrowLeft } from 'react-icons/fa';
import Navbar from './Navbar';
import './AccessDenied.css';

function AccessDenied() {
  const navigate = useNavigate();

  return (
    <div className="access-denied">
      <Navbar />
      <div className="access-denied-content">
        <div className="access-denied-container">
          <div className="access-denied-icon-container">
            <FaExclamationTriangle className="access-denied-icon" />
          </div>
          
          <div className="access-denied-message-container">
            <div className="access-denied-header">
              <img src="/WSP_LOGO-01.jpg" alt="WSP Logo" className="access-denied-logo" />
              <h1>Acceso Denegado</h1>
            </div>
            
            <div className="access-denied-message">
              <h2>Parece que no tienes permiso :(</h2>
              <p className="access-denied-details">
                La sección a la que intentaste acceder no está disponible para tu tipo de credenciales.
              </p>
              <p className="access-denied-help">
                Si crees que esto es un error, favor de contactar al administrador de la página.
              </p>
            </div>
          </div>
        </div>
        
        <button 
          className="access-denied-return-button" 
          onClick={() => navigate('/dashboard')}
        >
          <FaArrowLeft className="access-denied-button-icon" />
          <span>Regresar a tablero</span>
        </button>
      </div>
    </div>
  );
}

export default AccessDenied;